import { FC } from "react";

import EditorialSlide from "@/components/GuidedToolLauncher/EditorialSlide";
import FilterSlide from "@/components/GuidedToolLauncher/FilterSlide";
import { GuidedToolSlideProps } from "@/types";

const ModalToolSlide: FC<GuidedToolSlideProps> = ({ slide }) => {
  return (
    <div className="h-full md:h-[calc(100%-44px)] relative no-scrollbar">
      <div className="slide-header text-center md:text-left">
        <h3 className="font-primary font-medium text-m md:text-l uppercase pb-l gt-slide__title">{slide.question}</h3>
        <p className="pb-xl gt-slide__subtitle">{slide.suggestion}</p>
      </div>
      <div className="slide-content flex flex-col w-full h-[calc(100%-194px)] justify-center relative">
        {slide.type === "editorial" && <EditorialSlide slide={slide} />}
        {slide.type === "filter" && <FilterSlide slide={slide} />}
      </div>
    </div>
  );
};
export default ModalToolSlide;
